import { useEffect, useState } from "react";
import { Hooks } from "@xt/xtbase";
import { loadSocialMediaList } from "../api/socialMedia";
import { mapSocialMediaRows } from "../utils/socialMedia";

const { useTranslation } = Hooks;

/**
 * 顶栏 Help Center 与 Footer Community 共用。
 * 底层 loadSocialMediaList 有模块缓存，多次挂载也只打一次接口。
 */
export default function useSocialMediaLinks() {
  const t = useTranslation();
  const [socialLinks, setSocialLinks] = useState([]);

  useEffect(() => {
    let cancelled = false;
    loadSocialMediaList()
      .then((list) => {
        if (cancelled) return;
        setSocialLinks(mapSocialMediaRows(list, t));
      })
      .catch(() => {
        if (!cancelled) setSocialLinks([]);
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return socialLinks;
}
